import React from 'react';
import CustomModal from '../../../../../../../components/CustomModal';
import Form from './Form/index';

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: any;
  id_operacao_porto_carrossel_transportadora?: number;
}

const Create: React.FC<Props> = (props: Props) => {
  return (
    <CustomModal title={props.isEdit ? "Editar" : "Cadastrar"} onClose={props.onClear}>
      <Form isView={props.isView} selectedRow={props.selectedRow} onConfirm={props.onConfirm} isEdit={props.isEdit} onClose={props.onClear} id_operacao_porto_carrossel_transportadora={props.id_operacao_porto_carrossel_transportadora} />
    </CustomModal>
  );
}

export default Create;
